import { arrType, datatypes, inputTypes } from "data/globalData";

export const sourceOptions = {
	THOR: "THOR",
	RAREISM: "RAREISM",
};

export const defaultSource = sourceOptions.THOR;

/** BigQuery table backing each source, used for both filter options and the download. */
export const sourceTables = {
	[sourceOptions.THOR]: "adroit-standard-379209.MAYOOKH_THOR.SHOPIFY_INVENTORY",
	[sourceOptions.RAREISM]: "adroit-standard-379209.MAYOOKH_THOR.RSM_SHOPIFY_INVENTORY",
};

export const dropdownColumns = ["BRAND", "DIVISION"];

export const filterColArry = [
	{
		name: "Source",
		key: "SOURCE",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: defaultSource,
		select_options: {
			type: arrType,
			list: [
				{ name: sourceOptions.THOR, key: sourceOptions.THOR },
				{ name: sourceOptions.RAREISM, key: sourceOptions.RAREISM },
			],
		},
	},
	{
		name: "Brand",
		key: "BRAND",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 2,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [{ name: "Loading...", key: "Loading" }],
		},
	},
	{
		name: "Division",
		key: "DIVISION",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 3,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [{ name: "Loading...", key: "Loading" }],
		},
	},
];
